import { ref, type Ref } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class VersionService {
    private static _appVersion: Ref<string> = ref('');

    private constructor() {}

    public static async init(): Promise<void> {
        try {
            const versionResponse: Response = await fetch('/version.txt');

            this._appVersion.value = (await versionResponse.text()).trim();
        } catch (error: unknown) {
            console.error('Failed to fetch app version', error);
            this._appVersion.value = '';
        }
    }

    public static get appVersion(): string {
        return this._appVersion.value;
    }
}

export { VersionService };
